import './PageLoadingCircle.css';

export default function PageLoadingCircle({ pageHeight }) {
  return (
    <div className='page-loading-circle-page-wrapper'>
      <div className={`page-loading-circle-element-wrapper ${pageHeight}`}>
        <div className='page-loading-circle'></div>
      </div>
    </div>
  );
}
